import { render } from "./WidgetSection.vue?vue&type=template&id=3d4a4612&ts=true"
import script from "./WidgetSection.vue?vue&type=script&lang=ts"
export * from "./WidgetSection.vue?vue&type=script&lang=ts"

import "./WidgetSection.vue?vue&type=style&index=0&id=3d4a4612&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__